import { render } from "./MainTutorialIcon2.vue?vue&type=template&id=e4a6fb94&scoped=true&ts=true"
import script from "./MainTutorialIcon2.vue?vue&type=script&lang=ts"
export * from "./MainTutorialIcon2.vue?vue&type=script&lang=ts"

import "./MainTutorialIcon2.vue?vue&type=style&index=0&id=e4a6fb94&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4a6fb94"]])

export default __exports__